
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useSession } from "@supabase/auth-helpers-react";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Settings } from "lucide-react";

export function UserAvatar() {
  const session = useSession();
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
  const [fullName, setFullName] = useState<string>("");

  useEffect(() => {
    if (session?.user?.id) {
      const fetchProfile = async () => {
        const { data } = await supabase
          .from('profiles')
          .select('avatar_url, full_name')
          .eq('id', session.user.id)
          .single();
        
        if (data) {
          setAvatarUrl(data.avatar_url);
          setFullName(data.full_name || "");
        }
      };
      
      fetchProfile();
    }
  }, [session]);

  if (!session) {
    return <Settings className="w-5 h-5" />;
  }

  const getInitials = () => {
    if (fullName) {
      return fullName
        .split(' ')
        .map(name => name.charAt(0))
        .join('')
        .toUpperCase()
        .slice(0, 2);
    }
    return session.user.email?.charAt(0).toUpperCase() || "U";
  };

  return (
    <Avatar className="w-6 h-6">
      <AvatarImage src={avatarUrl || undefined} alt="User avatar" />
      <AvatarFallback className="text-xs bg-app-accent text-app-accent-foreground">
        {getInitials()}
      </AvatarFallback>
    </Avatar>
  );
}
